<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" fill="none" viewBox="0 0 19 19">
  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m17.75 17.75-4.197-4.197M15.75 8.25a7.5 7.5 0 1 0-15 0 7.5 7.5 0 0 0 15 0Z"/>
</svg>
